import React from "react";
import { Spinner } from "reactstrap";
import styled from "styled-components";

const LoadingArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
`;
const LoadingHeading = styled.h1`
  color: rgb(78, 115, 223);
`;
const LoadingSpinner = styled.div`
  margin-left: 2rem;
  padding-top: 0rem;
`;

function Loading({ title = "Loading" }) {
  return (
    <LoadingArea>
      <LoadingHeading>{title}</LoadingHeading>
      <LoadingSpinner>
        <Spinner color="primary" />
      </LoadingSpinner>
    </LoadingArea>
  );
}

export default Loading;
